import { useEffect, useMemo, useState } from 'react';

import { useTeacherOrStudentClassSettings } from 'approot/activity-builder/present/activity-present-settings.hooks';
import prefersReducedMotion from 'approot/shared/ally/prefers-reduced-motion';

export const usePausePlaySettings = () => {
  const { animationAutoPlay } = useTeacherOrStudentClassSettings();

  const shouldAutoPlay = useMemo(
    () => (prefersReducedMotion() ? false : animationAutoPlay),
    [animationAutoPlay]
  );

  const [isPlaying, setIsPlaying] = useState<boolean>(animationAutoPlay);

  useEffect(() => {
    setIsPlaying(shouldAutoPlay);
  }, [shouldAutoPlay]);

  return {
    isPlaying,
    shouldAutoPlay,
    setIsPlaying,
  };
};
